import { engineComponent, ArrayUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ImageElement, ImageElementAttributes } from "../Components/Elements/Graphics/ImageElement";
import { Attributes } from "../Utils/Attributes";
import { StageController } from "../Components/StageController";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { Tweens } from "../Components/Effects/Tweens";

@engineComponent(ComponentTypes.DisplayObject)
export class MaskElement extends ImageTextCounterElement {
    private maskImage: ImageElement;

    public create(node: Element): void {
        super.create(node);

        Tweens.removeTweens(this.maskImage, "alpha");
        Tweens.removeTweens(this.maskImage, "position");
        Tweens.removeTweens(this.maskImage, "rotation");
        Tweens.removeTweens(this.maskImage, "scale");

        if (node.hasAttribute(ImageMaskElemenetAttributes.MASK_IMAGE)) {
            this.maskImage = new ImageElement(
                StageController.getTextureByResourceId(node.getAttribute(ImageMaskElemenetAttributes.MASK_IMAGE)),
            );

            if (this.maskImage != null) {
                this.maskSprite = this.maskImage;
                if (node.hasAttribute(ImageMaskElemenetAttributes.MASK_POSITION_X)) {
                    this.maskSprite.position.x = parseFloat(
                        node.getAttribute(ImageMaskElemenetAttributes.MASK_POSITION_X),
                    );
                }
                if (node.hasAttribute(ImageMaskElemenetAttributes.MASK_POSITION_Y)) {
                    this.maskSprite.position.y = parseFloat(
                        node.getAttribute(ImageMaskElemenetAttributes.MASK_POSITION_Y),
                    );
                }
                if (node.hasAttribute(ImageMaskElemenetAttributes.MASK_PIVOT_X)) {
                    this.maskSprite.pivot.x = parseFloat(node.getAttribute(ImageMaskElemenetAttributes.MASK_PIVOT_X));
                }
                if (node.hasAttribute(ImageMaskElemenetAttributes.MASK_PIVOT_Y)) {
                    this.maskSprite.pivot.y = parseFloat(node.getAttribute(ImageMaskElemenetAttributes.MASK_PIVOT_Y));
                }

                this.addChild(this.maskSprite);

                // this.bitmapText.addChild(this.maskSprite); // funguje
                this.bitmapText.mask = this.maskSprite;
                // this.bitmapText.mask = this.maskSprite;
            } else {
                if (DEBUG) {
                    this.log(
                        "ERROR" +
                            this.componentName +
                            " no image with name for mask: " +
                            node.getAttribute(ImageElementAttributes.BITMAP_MASK),
                    );
                }
            }
        }

        if (node.hasAttribute(ImageMaskElemenetAttributes.MASK_POSITION_X)) {
            this.maskSprite.position.x = parseFloat(node.getAttribute(ImageMaskElemenetAttributes.MASK_POSITION_X));
        }
        if (node.hasAttribute(ImageMaskElemenetAttributes.MASK_POSITION_Y)) {
            this.maskSprite.position.y = parseFloat(node.getAttribute(ImageMaskElemenetAttributes.MASK_POSITION_Y));
        }

        this.runMaskPositionTween(node);
    }

    private runMaskPositionTween(node: Element) {
        if (
            !node.hasAttribute(ImageMaskElemenetAttributes.MASK_POSITION_TWEEN_X) ||
            !node.hasAttribute(ImageMaskElemenetAttributes.MASK_POSITION_TWEEN_Y)
        ) {
            return false;
        }

        let positionTweenX: Array<number> = ArrayUtils.numberArray(
            node.getAttribute(ImageMaskElemenetAttributes.MASK_POSITION_TWEEN_X),
        );
        let positionTweenY: Array<number> = ArrayUtils.numberArray(
            node.getAttribute(ImageMaskElemenetAttributes.MASK_POSITION_TWEEN_Y),
        );

        const tweenX: Array<number> = positionTweenX || [];
        const tweenY: Array<number> = positionTweenY || [];
        const tweenEase: string = null;
        const tweenDuration: number = Attributes.assignIntAttribute(
            node,
            ImageMaskElemenetAttributes.MASK_POSITION_TWEEN_DURATION,
            120,
        );
        const tweenDelay: number = Attributes.assignIntAttribute(
            node,
            ImageMaskElemenetAttributes.MASK_POSITION_TWEEN_DELAY,
            0,
        );
        const tweenLoop: boolean = false;

        Tweens.positionTween(this.maskImage, { tweenX, tweenY, tweenEase, tweenDuration, tweenDelay, tweenLoop });
    }
}

const ImageMaskElemenetAttributes = {
    MASK_IMAGE: "MaskImage",
    MASK_POSITION_X: "MaskPositionX",
    MASK_POSITION_Y: "MaskPositionY",
    MASK_PIVOT_X: "MaskPivotX",
    MASK_PIVOT_Y: "MaskPivotY",

    MASK_POSITION_TWEEN_X: "MaskPositionTweenX",
    MASK_POSITION_TWEEN_Y: "MaskPositionTweenY",
    MASK_POSITION_TWEEN_DURATION: "MaskPositionTweenDuration",
    MASK_POSITION_TWEEN_DELAY: "MaskPositionTweenDelay",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/MaskElement.ts
 **/